<template>
<div>
  <div v-if="isLoading">
    <v-progress-linear
      indeterminate
      color="primary"
      ></v-progress-linear>
  </div>
  <v-container fluid>
    <search-bar
        v-model="query.search"
        :label="searchLabel"
        v-on:clear="clearSearch"
        v-on:request-search="onRequestSearch"
    />
    <v-row>

        <v-col
          cols="12"
          sm="12" md="6"
        >
          <v-autocomplete
            solo
            autocomplete="off"
            label="Select public writer"
            item-text="name_address"
            clearable
            item-value="id"
            @change="publicWriterSelected"
            v-bind:items="publicWriters"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          sm="12" md="6"
        >
            <v-text-field
              label="Select date"
              solo
              clearable
              readonly
              v-model="formattedDate"
              @click:clear="dateClearCallback"
              prepend-icon="mdi-calendar"
              @click="showDatePicker"
            ></v-text-field>
        </v-col>

    </v-row>
    </v-container>
    <v-pagination
      v-if="this.pagination != undefined"
      v-model="pagination.currentPage"
      v-bind:length="pagination.pageCount"
      circle
      v-on:input = "onRequestPageChange"
    ></v-pagination>

    <div v-if="!isLoading && this.articles !== null">
      <v-row class="ma-1">
        <v-col
          v-if="this.articles.length<=0"
        >
          <v-banner
            single-line
            class="text-h6"
          >
            No records
          </v-banner>
        </v-col>
        <v-col
          sm="12" md="6"
          v-for="item in articles"
          :key="item.id"
          class="d-flex child-flex"
        >
          <article-card @priorityChanged="priorityChangeCallback" :showPriorityField="showPriorityOrderField" :data="item" @delete_success="articleDeletedCallback"></article-card>
        </v-col>
      </v-row>
    </div>
        <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>

 </div>
</template>

<script>
// import snackbar from '@/utils/snackbar'
import postApi from '@/api/postApi'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import publicWriterApi from '@/api/pwApi'
import * as dateFormats from '@/constants/dateFormats'

export default {
  components: {
    'search-bar': () => import('@/components/SearchBar'),
    'article-card': () => import('@/components/ArticleCard'),
    DatePickerDialog

  },
  mounted () {
    // when returning from edit/add news
    if (window.publish_date) {
      this.query.publish_date = window.publish_date
      window.publish_date = null
      this.formattedDate = this.$moment(this.query.publish_date).format(dateFormats.DDMMYY)
    }
    this.init()
  },
  data: function () {
    return {
      searchLabel: 'Search for title or body',
      isLoading: false,
      articles: null,
      formattedDate: null,
      showPriorityOrderField: false,
      showDatePickerDialog: false,
      public_writers: ['Type to search'],
      query: {
        search: null,
        sort: 'publish_date:desc',
        public_writer_id: null,
        publish_date: null,
        date: null,
        only_public_article: 1,
        item_per_page: 16
      },
      publicWriters: null,

      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      }
    }
  },
  methods: {
    publicWriterSelected (id) {
      this.$log.info('public writer selected', [id])
      this.query.public_writer_id = id
      this.query.page = 1
      this.togglePriorityField()
      this.fetchArticle()
    },
    togglePriorityField () {
      this.$log.info('togglel priority field', [this.query.publish_date, this.query.public_writer_id])
      if (this.query.publish_date !== null) {
        this.showPriorityOrderField = true
        this.query.sort = 'order:asc'
      } else {
        this.showPriorityOrderField = false
        this.query.sort = 'publish_date:desc'
      }
    },
    async init () {
      await this.fetchPublicWriters()
      await this.fetchArticle()
    },

    async fetchPublicWriters () {
      this.isLoading = true
      try {
        const k = await publicWriterApi.writers({ all: 1 })
        if (k.data !== undefined) {
          this.publicWriters = k.data
        }
      } finally {
        this.isLoading = false
      }
    },
    priorityChangeCallback () {
      this.fetchArticle()
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.query.publish_date = null
      this.togglePriorityField()
      this.fetchArticle()
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.query.publish_date = dateUtils.parseDate(data)
      this.togglePriorityField()
      this.fetchArticle()
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },

    articleDeletedCallback () {
      this.fetchArticle()
    },

    async fetchArticle () {
      this.$log.info('Fetching article with parama', [this.query])
      this.isLoading = true
      try {
        const response = await postApi.getArticles(this.query)
        if (response.data !== undefined) {
          this.articles = response.data.data
          this.parsePaginationData(response.data)
        }
      } finally {
        this.isLoading = false
      }
    },
    onRequestSearch () {
      this.query.page = 1
      this.fetchArticle()
    },
    clearSearch () {
      this.query.search = null
      this.query.page = 1
      this.fetchArticle()
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchArticle()
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.total = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    }

  }
}
</script>
